import { Box, Flex, Text } from "@chakra-ui/react";

export function TotalCommissionActiveCommunityBanner({ amount }) {
  const formatter = new Intl.NumberFormat("id-ID");
  return (
    <Box backgroundColor="#E9FFF2">
      <Flex gap="12px" alignItems="center" padding="12px 16px">
        <Text fontWeight="400" fontSize="14px" lineHeight="19px" color="#5C5C5C" mb="0">
          Total Commission from Active Community
        </Text>
        <Text color="#000" fontWeight="400" fontSize="20px" mb="0">
          Rp{!!amount ? formatter.format(amount) : 0}
        </Text>
      </Flex>
    </Box>
  );
}